var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',[_c('v-btn',{staticClass:"float-right",attrs:{"color":"grey","icon":""},on:{"click":function($event){return _vm.$emit('closeLayoutEditMode')}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v(" fa-times ")])],1),_vm._v(" "+_vm._s(_vm.layoutEditorNotAvailableMessage)+" ")],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }